// extracted by mini-css-extract-plugin
export default {"root":"Switch_root__4CT5d","toggle":"Switch_toggle__6jJ4a","checked":"Switch_checked__yx66n","disabled":"Switch_disabled__gm36K"};